import { HttpForm } from "../Support/HttpForm";
import { axios } from "../Support/Axios";
import { Account } from "../Account/Account";
export class UserInvite extends HttpForm {
    data = {
        name: '',
        email: '',
        role: null,
        account: null,
    };
    accounts = false;
    app;
    constructor(app) {
        super();
        this.app = app;
    }
    invite() {
        const url = '/api/user';
        this.setupFormSubmission();
        return axios.post(url, this.data)
            .then(() => this.navigation.goBack())
            .catch(e => this.setError(e));
    }
    mount() {
        if (this.app) {
            this.data.account = this.app.auth.account;
        }
        if (this.isAdminUser()) {
            this.account()
                .all()
                .then((response) => {
                this.accounts = response.data.data;
                this.setLoadingState(true);
            })
                .catch(e => this.setError(e));
        }
        else {
            this.setLoadingState(true);
        }
    }
    isAdminUser() {
        if (this.app && this.app.auth) {
            return this.app.auth.role === 'admin';
        }
        return false;
    }
    account() {
        return new Account;
    }
}
